import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgInfoCircleLine = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      d='M10.75 6.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0M14.25 17a1 1 0 0 1-1 1h-2a1 1 0 1 1 0-2v-4.5a1 1 0 0 1-.447-1.894l1-.5A1 1 0 0 1 13.25 10v6a1 1 0 0 1 1 1'
    />
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M12 1c-3.487 0-6.287.873-8.207 2.793S1 8.513 1 12s.873 6.287 2.793 8.207S8.513 23 12 23s6.287-.872 8.207-2.793C22.127 18.287 23 15.487 23 12s-.872-6.287-2.793-8.207C18.287 1.873 15.487 1 12 1M3 12c0-3.18.794-5.38 2.207-6.793S8.821 3 12 3s5.38.794 6.793 2.207S21 8.821 21 12s-.794 5.38-2.207 6.793S15.179 21 12 21s-5.38-.794-6.793-2.207S3 15.179 3 12'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgInfoCircleLine)
export default ForwardRef
